/**
 * Bake page numbers onto every PDF page and download the result.
 */

import {
  bakeWatermarkedPdf,
  downloadBlob,
} from "../../shared/bakeWatermarkedPdf";
import { pageNumberSettingsToWatermarkPreview } from "./pageNumberSettings";

/**
 * @param {File} file
 * @param {object} pageNumbers — DEFAULT_PAGE_NUMBER_SETTINGS shape
 * @param {{ scale?: number, maxPages?: number, onProgress?: Function }} [opts]
 */
export async function bakePageNumbersPdf(file, pageNumbers, opts = {}) {
  if (!file) throw new Error("No PDF file");
  if (!pageNumbers?.enabled) throw new Error("Page numbers are disabled");

  return bakeWatermarkedPdf(
    file,
    (pageNum, total) =>
      pageNumberSettingsToWatermarkPreview(pageNumbers, pageNum, total),
    {
      ...opts,
      fileNameSuffix: "page-numbers",
    }
  );
}

/**
 * Bake + trigger browser download.
 */
export async function downloadPageNumbersPdf(file, pageNumbers, opts = {}) {
  const result = await bakePageNumbersPdf(file, pageNumbers, opts);
  downloadBlob(result.blob, result.fileName);
  return result;
}
